/* dropdownIndicator.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./dropdownIndicator.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import CloseIcon from '@atlaskit/icon/core/cross-circle';
import SearchIcon from '@atlaskit/icon/core/search';
import { Pressable } from '@atlaskit/primitives/compiled';
import { components } from '@atlaskit/select';
var styles = {
  customDropdownIndicatorStylesOld: "_1e0c1txw _80omtlke _1bah1h6o _1bsbzwfg",
  customDropdownIndicatorStyles: "_1e0c1txw _80omtlke _1bah1h6o _1bsbzwfg _bfhk1j28 _syazazsu"
};
var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
  var selectProps = props.selectProps;
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(Pressable, {
    xcss: styles.customDropdownIndicatorStyles,
    onClick: function onClick() {
      if (selectProps.inputValue) {
        selectProps.onInputChange && selectProps.onInputChange('', {
          action: 'input-change',
          prevInputValue: selectProps.inputValue
        });
      }
    }
  }, selectProps.inputValue ? /*#__PURE__*/React.createElement(CloseIcon, {
    label: ""
  }) : /*#__PURE__*/React.createElement(SearchIcon, {
    label: ""
  })));
};
export default CustomDropdownIndicator;